export default {
    en: {
        sell_tickets: 'Sell tickets',
        other_provider: 'Other provider',
        sell_intro_header_title: 'Where did you purchase the tickets?',
        sell_intro_header_subtitle: 'Choose the ticket provider you bouight your tickets from:',
        select_provider_iabilet: 'From iabilet.ro',
        select_other_provider: 'From somewhere else',
        sell_iabilet_provider: 'Sell your tickets from IaBilet.ro',
        sell_other_provider: 'Sell your tickets from other ticket provider',
        provider_name: 'Where did you buy the tickets?',
        your_email: 'Your Email',
        sell_select_event: 'Select the event',
        sell_select_event_desc: 'We have identified one eligible event from your IaBielt account. Please select the event from the list or add your ticket manually.',
        sell_select_tickets_to_sell: 'Select the tickets you want to sell',
        sell_select_tickets_to_sell_desc: 'Please select the ones you want to sell',
        sell_enter_sell_price: 'Enter the sell price',
        sell_add_tickets_sell_price: 'Add the tickets sell price',
        sell_add_tickets_sell_price_desc: 'Enter the price you’d like to resell each ticket for. To help prevent speculative practices, the dăBilet.ro platform sets a maximum resale price, based on the ticket’s original value. This limit includes a fee that covers processing and service costs.',
        sell_you_paid_from: 'You paid from',
        sell_you_paid: 'You paid',
        per_ticket: 'per ticket',
        for_this_ticket: 'for this ticket',
        sell_you_bought: 'You bought {noOfTickets} tickets',
        sell_how_much: 'How much',
        sell_add_bank_account_info: 'Add your bank account information',
        sell_add_bank_account_desc: 'We ll send the payment to your account after the event occurs',
        sell_add_bank_account_desc_form: 'Please enter below the IBAN account through which you wish to receive the money upon completion of the sale:',
        sell_bank_account_alert: 'Don\'t worry, the IBAN account can only be used to receive an amount of money',
        sell_bank_account_name: 'Account owner',
        sell_bank_account_future_use: 'Save this account information for future use',
        sell_publish_tickets: 'Publish tickets',
        sell_summary: 'Summary',
        sell_new_price: 'New price',
        sell_tax: 'Handling fee',
        sell_your_money: 'You will receive',
        sell_how_do_you_want_to_sell_your_tickets: 'How do you want to sell your tickets',
        sell_allow_to_sell_the_tickets_together: 'I allow to sell the tickets only together',
        sell_allow_partial_sale_of_tickets: 'I allow to sell the tickets separately',
        sell_seat_together: 'The seats are together',
        sell_agree_with: 'I agree with',
        sell_terms_and_conditions: 'terms and conditions',
        sell_one_final_step: 'One final step...',
        sell_check_information_below: 'Check the information below',
        sell_we_are_done: 'And... we\'re done',
        sell_we_have_successfully_posted_your_listing: 'We have successfully posted your listing.',
        connect_modal_subtitle: 'Start selling your tickets!',
        connect_modal_desc: 'Use your IaBilet account for authentication to easily find the tickets you want to sell.',
        connect_iabilet_account: 'You already have an account on iaBilet.ro with this email address. Log in by clicking the button below:',
        already_have_account: 'Do you have an account?',
        already_a_member: 'Already a member?',
        register_modal_alternative: 'or create your account below',
        login_modal_alternative: 'or sign in to your account with',
        login_modal_email_placeholder: 'Enter your email',
        login_modal_confirm_email_placeholder: 'Confirm your email',
        login_modal_first_name: 'First name',
        login_modal_last_name: 'Last name',
        login_modal_mobile_phone: 'Phone',
        login_modal_email_btn_text: 'Continue with email',
        login_modal_password: 'Password',
        login_modal_remember: 'Remember me',
        login_modal_forgot_password: 'Forgot password?',
        login_modal_email_contiune: 'Continue',
        login_modal_footer_continue: 'By proceeding, you agree to our',
        login_modal_footer_terms: 'terms and conditions',
        login_modal_footer_ours: ' ',
        login_already_have_account: 'Already have an account?',
        agree_terms: 'I agree with the',
        agree_terms_text: 'terms and conditions',
        agree_terms_website: ' of the site',
        sing_in: 'Sign in',
        sell_faq_title: 'Frequently Asked Questions',
        question1: 'What are the requirements to list my tickets for sale?',
        answer1: 'For the ticket to be resold, it must be purchased from a dăbilet.ro accredited website. You can resell it with a markup of up to 20% over the ticket price. Of this 20%, 10% + VAT represents the dăbilet commission for processing and resale intermediation. The remaining 8% should cover the additional costs you incurred when purchasing the ticket.',
        question2: 'Will I be charged for listing tickets on your site?',
        answer2: 'It is free to list your tickets on Dăbilet.ro, but there is a resale intermediation commission! Once your tickets are sold, a commission of 10% + VAT will be deducted from the total sale price. This fee helps us ensure a smooth transaction between you and the buyer of your tickets. If your tickets don\'t sell, you will not be charged. Listing is free.',
        question3: 'At what price can I resell my tickets?',
        answer3: 'You can resell your tickets at a price up to 20% higher than their original price. Of course, you can also sell them at a lower price if you want to get rid of them quickly, but keep in mind that a commission of 10% + VAT will be deducted from the final amount at which you list them for sale.',
        question4: 'Can I sell my tickets from mobile, you have an app?',
        answer4: 'Yes, you can create new listings via the Dăbilet mobile app on your Android or iOS device.',
        other_provider__sorry: 'Sorry... for now',
        other_provider__sorry__text: 'At this moment we do not have any integration with other provider. But we assure you that we are doing everything we can to allow you to sell tickets bought from other provider as soon as possible.',
        other_provider_notify: 'Notify me when available',
        sell_tickets_manually_title_with_event: 'or add your tickets manually',
        sell_tickets_manually_title_without_event: 'Add your tickets manually',
        sell_tickets_manually_text: 'Add the codes of the tickets you want to sell',
        sell_tickets_manually_text_codes: 'The code is the 12-character string below the QR code on the ticket.',
        add_tickets: 'Add tickets',
        add_ticket_code: 'Add ticket/s code',
        add_ticket_code_text_1: 'Add the codes of the tickets you want to sell',
        add_ticket_code_text_2: 'Enter your ticket/s code, it can be found under the QR code from your ticket.',
        enter_ticket_code: 'Enter ticket code',
        ticket: 'Ticket',
        validate_ticket: 'Validate tickets',
        add_new_ticket: 'Add new ticket code',
        tickets_are_valid: 'Tickets are valid. Add your ticket/s by clicking the button below.',
        add_code_printed_ticket: 'Add the code printed on your ticket',
        multiple_events_warning: 'We noticed that you entered codes from different events. You need to add ticket codes from a single event',
        buy_price: 'Buy price',
        buy_price_placeholder: 'Max: {price}',
        notify_error_message: 'There was an error with your request. Please try again',
        sell_no_events: 'We did not find any tickets associated with your iabilet account. Please add manually the codes from the received tickets by clicking the button below.',
        select_all: 'Select all',
        deselect_all: 'Deselect all',
    },
    ro: {
        sell_tickets: 'Vinde bilete',
        other_provider: 'Alt furnizor',
        sell_intro_header_title: 'De unde ai cumpărat biletele?',
        sell_intro_header_subtitle: ' ',
        select_provider_iabilet: 'De la iabilet.ro',
        select_other_provider: 'Din alta parte',
        provider_name: 'De unde ai cumpărat biletele?',
        your_email: 'Email tău',
        sell_select_event: 'Selectează evenimentul',
        sell_select_event_desc: 'Am identificat un eveniment eligibil din contul tău IaBilet. Te rugăm să selectezi evenimentul din listă sau să adaugi biletul manual.',
        sell_select_tickets_to_sell: 'Selectează ce biletele vrei să pui în vânzare',
        sell_select_tickets_to_sell_desc: 'Te rugăm să selectezi biletele pe care vrei să le vinzi',
        sell_enter_sell_price: 'Introdu prețul de vânzare',
        sell_add_tickets_sell_price: 'Adaugă prețul de vânzare al biletelor',
        sell_add_tickets_sell_price_desc: 'Listează prețul dorit pentru revânzarea fiecărui bilet. Pentru a preveni practicile speculative, platforma dăBilet.ro impune o limită maximă pentru prețul de revânzare, calculată în funcție de prețul original al biletului. Această limită include un comision care acoperă costurile de procesare și intermediere.',
        sell_you_paid_from: 'Ai plătit de la',
        sell_you_paid: 'Ai plătit',
        per_ticket: 'pe bilet',
        for_this_ticket: 'pentru acest bilet',
        sell_you_bought: 'Ai cumpărat {noOfTickets} bilete',
        sell_how_much: 'Cât',
        sell_add_bank_account_info: 'Adaugă informațiile contului bancar',
        sell_add_bank_account_desc: 'Vom trimite plata în contul tău după ce evenimentul a avut loc',
        sell_add_bank_account_desc_form: 'Vă rugăm să introduceți mai jos contul IBAN prin care doriți să primiți banii la finalizarea vânzării:',
        sell_bank_account_alert: 'Nu vă faceți griji, contul IBAN poate fi folosit doar pentru a primi o sumă de bani',
        sell_bank_account_name: 'Titular cont',
        sell_bank_account_future_use: 'Salvează aceste informații de cont pentru utilizare ulterioară',
        sell_publish_tickets: 'Publică biletele',
        sell_summary: 'Sumar',
        sell_new_price: 'Preț nou',
        sell_tax: 'Taxa de manipulare si prezentare',
        sell_your_money: 'Vei primi',
        sell_how_do_you_want_to_sell_your_tickets: 'Cum vrei să vinzi biletele tale',
        sell_allow_to_sell_the_tickets_together: 'Permit să vând biletele doar împreună',
        sell_allow_partial_sale_of_tickets: 'Permit să vând biletele separat',
        sell_seat_together: 'Locurile sunt împreună',
        sell_agree_with: 'Sunt de acord cu',
        sell_terms_and_conditions: 'termenii și condițiile',
        sell_one_final_step: 'Un singur pas final...',
        sell_check_information_below: 'Verifică informațiile de mai jos',
        sell_we_are_done: 'Și... am terminat',
        sell_we_have_successfully_posted_your_listing: 'Am postat cu succes anunțul tău.',
        connect_modal_subtitle: 'Începe să-ți vinzi biletele!',
        connect_modal_desc: 'Folosește-ți contul de IaBilet pentru autentificare pentru a găsi ușor biletele pe care vrei să le vinzi.',
        connect_iabilet_account: 'Ai deja un cont pe iaBilet.ro cu aceasta adresa de e-mail. Loghează-te apăsând butonul de mai jos:',
        already_have_account: 'Ai deja un cont?',
        already_a_member: 'Ești deja membru?',
        register_modal_alternative: 'sau creează cont mai jos',
        login_modal_alternative: 'sau autentifică-te în contul tău cu',
        login_modal_email_placeholder: 'Email',
        login_modal_confirm_email_placeholder: 'Confirmă email',
        login_modal_email_btn_text: 'Continuă cu email',
        login_modal_first_name: 'Prenume',
        login_modal_last_name: 'Nume',
        login_modal_mobile_phone: 'Telefon',
        login_modal_password: 'Parolă',
        login_modal_remember: 'Ține-mă minte',
        login_modal_forgot_password: 'Ai uitat parola?',
        login_modal_email_contiune: 'Continuă',
        login_modal_footer_continue: 'Continuând, ești de acord cu',
        login_modal_footer_terms: 'termenii și condițiile',
        login_modal_footer_ours: 'noastre',
        login_already_have_account: 'Ai deja un cont?',
        agree_terms: 'Sunt de acord cu ',
        agree_terms_text: 'termenii și condițiile',
        agree_terms_website: 'site-ului',
        sing_in: 'Conectează-te',
        sell_faq_title: 'Întrebări frecvente',
        question1: 'Care sunt cerințele pentru a lista biletele mele pentru vânzare?',
        answer1: 'Pentru a putea fi revândut, biletul dumneavoastră trebuie să fie cumpărat de pe un site acreditat dăbilet.ro. Puteți să îl revindeți cu un adaos de maximum 20% față de prețul biletului. Din acești 20%, 10% + TVA reprezintă comisionul dăbilet de procesare și intermediere revânzare. Restul de 8% ar trebui să vă acopere costurile suplimentare plătite de dvs. la achiziția biletului.',
        question2: 'Voi fi taxat pentru listarea biletelor pe site-ul dvs.?',
        answer2: 'Este gratuit să vă listați biletele pe Dăbilet.ro, dar aveți un comision de intermediere revânzare! Odată ce biletele dvs. s-au vândut, un comision de 10% + TVA va fi dedus din prețul total de vânzare. Această taxă ne ajută să asigurăm o tranzacție fără probleme între dvs. și cumpărătorul biletelor dumneavoastră. Dacă biletele tale nu se vând, nu vei fi taxat. Listarea este gratuită.',
        question3: 'La ce preț pot să-mi revând biletele?',
        answer3: 'Vă puteți revinde biletele cu un preț mai mare cu maxim 20% față de prețul acestora. Desigur, le puteți vinde și mai ieftin dacă doriți să scăpați rapid de ele, dar nu uitați că un comision de 10% + TVA va fi reținut din suma finală la care le puneți la vânzare.',
        question4: 'Pot să-mi vând biletele de pe mobil, aveți o aplicație?',
        answer4: 'Da, puteți vinde bilete noi prin aplicația mobilă Dăbilet de pe dispozitivul dvs. Android sau iOS.',
        other_provider__sorry: 'Ne pare rău... Deocamdată',
        other_provider__sorry__text: 'În acest moment nu avem nicio integrare cu alt furnizor. Dar vă asigurăm că facem tot ce putem pentru a vă permite să vindeți biletele cumpărate de la alt furnizor cât mai curând posibil.',
        other_provider_notify: 'Anunță-mă când este disponibil',
        sell_tickets_manually_title_with_event: 'sau adaugă biletele manual',
        sell_tickets_manually_title_without_event: 'Adaugă biletele manual',
        sell_tickets_manually_text: 'Adăugați codurile biletelor pe care doriți să le vindeți.',
        sell_tickets_manually_text_codes: 'Codul este string-ul de 12 caractere de sub codul QR de pe bilet.',
        add_tickets: 'Adaugă biletele',
        add_ticket_code: 'Adaugă codurile biletelor',
        add_ticket_code_text_1: 'Adăugați codurile biletelor pe care doriți să le vindeți.',
        add_ticket_code_text_2: 'Introduceți codul biletului, acesta poate fi găsit sub codul QR de pe bilet.',
        ticket: 'Bilet',
        validate_ticket: 'Verifică',
        add_new_ticket: 'Adaugă un cod nou de bilet',
        tickets_are_valid: 'Biletele sunt valabile. Adăugați biletul/biletele apăsând butonul de mai jos.',
        add_code_printed_ticket: 'Adăugați codul tipărit pe biletul dvs.',
        multiple_events_warning: 'Am observat ca ai introdus coduri de la evenimente diferite. Trebuie să adaugi coduri de bilete de la un sigur eveniment',
        buy_price: 'Preț cumpărare',
        buy_price_placeholder: 'Max: {price}',
        notify_error_message: 'A apărut o eroare. Vă rugăm să încercați din nou',
        enter_ticket_code: 'Introduceți codul biletului',
        sell_no_events: 'Nu am găsit bilete asociate contului dumneavoastră iabilet. Vă rugăm să adăugați manual codurile de pe biletele primite apăsând pe butonul de mai jos',
        select_all: 'Selectează tot',
        deselect_all: 'Deselectează tot',
    },
};
